import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {


  transform(array: any[], field: string, value?): any[] {
    if (!array) { return []; }
    return array.filter(it => ((!value && value !== undefined) && it[field]) || (value === undefined && !it[field]) || (value && value === it[field]));
  }
}
